<template>
  <div class="main-bg">
    <el-container>
      <el-header style="min-height:8.84rem;height: auto;">
        <ResourceHeader ref="header"></ResourceHeader>
      </el-header>
      <el-container class="main-box">
        <el-aside width="12.188rem">
          <ResourceLeft ref="left"></ResourceLeft>
        </el-aside>
        <el-main ref="mains">
          <router-view :key="$route.path"></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>

  import ResourceHeader from '../../components/resource/Header.vue'
  import ResourceLeft from '../../components/resource/Leftnav.vue'

  export default {
    name: 'PortalIndex',
    components: {
      ResourceHeader, ResourceLeft
    },
    data() {
      return {};
    },

    mounted() {
    },

    methods: {},
  };
</script>

<style lang="less" scoped>
  .main-bg {
    width: 100%;
    height: 100%;
    background: url('../../assets//image//resource/res_main.png');

    .main-box {
      width: 62.5rem;
      margin: 0 auto;
      margin-top: 1.042rem;
      margin-bottom: 2.083rem;

      .el-aside {
        background-color: #fff;
        padding: 1.563rem 0.417rem 0.417rem;

      }

      .el-main {
        margin-left: 1.042rem;
        background-color: #fff;
        padding-right: 1.042rem;
        padding-top: 1.042rem;
        padding-left: 1.042rem;
        min-height: 1000px;
      }
    }
  }

  .el-header {
    padding: 0 0px;
  }
</style>
